// extracted by mini-css-extract-plugin
export default {"form":"_c6LNA5PgGG3JscrFBhJ","header":"eUbEG8AweAMF5VGt0Yh9","main":"dSTi_8kMrDGwvw5VvWAS","footer":"Or4Vfp7zuorH7sFLSiC9","scroll":"AV72j9Oa9PNfGdWqe8d2"};